/**
 * * Обновление тегов проекта
 */
export default class UpdateProjectTagsItem  {
	/**
	 * * Название тега
	 */
	Name!: string;
	/**
	 * * Описание
	 */
	Description!: string;
	/**
	 * * Номер типа
	 */
	TagId?: number;
	/**
	 * * Цвет
	 */
	Color!: string;
	/**
	 * * Порядковый номер
	 */
	Number!: number;
	constructor(obj?: Partial<UpdateProjectTagsItem>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
